import * as CostCodesActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 0,
  take: 10,
  sort: { field: 'name', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageCostCodes = {
  items: [],
  params: defaultParams
};

const costCodeState = {
  ManageCostCodes: ManageCostCodes,
  ErrorMsg: '',
  dateTime: new Date(),
  costCodeSelectList: []
};

export default function RoomStore(state = costCodeState, action) {
  switch (action.type) {
    case CostCodesActionType.SEARCH_COST_CODE_SUCCESS:
      return processSearchSuccess(state, action);

    case CostCodesActionType.SEARCH_COST_CODE_FAIL:
      return {
        ...state,
        ManageCostCodes
      };
    case CostCodesActionType.CREATE_COST_CODE_ERROR:
    case CostCodesActionType.EDIT_COST_CODE_ERROR:
      return {
        ...state,
        ErrorMsg: action.data
      };
    case CostCodesActionType.CREATE_COST_CODE_ASYNC:
    case CostCodesActionType.EDIT_COST_CODE_ASYNC:
    case CostCodesActionType.CREATE_COST_CODE_SUCCESS:
    case CostCodesActionType.EDIT_COST_CODE_SUCCESS:
    case CostCodesActionType.RESET_ERROR_MESSAGE:
      return {
        ...state,
        ErrorMsg: ''
      };
    // case CostCodesActionType.GET_COST_CODE_SELECT_LIST_ASYNC: {
    //   return {
    //     ...state,
    //     costCodeSelectList: []
    //   };
    // }
    case CostCodesActionType.GET_COST_CODE_SELECT_LIST_SUCCESS: {
      return {
        ...state,
        costCodeSelectList: action.data
      };
    }
    case CostCodesActionType.RESET_COST_CODE:
      return {
        ...state,
        ManageCostCodes: ManageCostCodes
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageCostCodes = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageCostCodes: manageCostCodes,
    ErrorMsg: ''
  };
};



// WEBPACK FOOTER //
// ./src/CostCodes/reducers.js